module.exports = __webpack_public_path__ + "img/左太极.aeff9cca.gif";